module.exports = __webpack_public_path__ + "img/edit-active.edf36da2.svg";